import React from 'react'
import cx from 'classnames'
import Grid from '@mui/material/Grid'
import MuiButton from '@mui/material/Button'
import { dismissPopover } from 'services/OverlayService'
import { guardMarketsAccess } from 'helpers/marketsAccess'
import TealToolTip from 'components/TealToolTip'

export default ({
  selectedDeals,
  disabled,
  handleDeselectAll,
  handleCompareSelectedDeals,
  setSignUpModalIsOpen,
  setUserRolesModalIsOpen,
  isLogged,
  hasMarketsAccess
}) => (
  <Grid container spacing={2} justifyContent='space-around'>
    <Grid item xs={12} sm={12} md={6} lg={4}>
      <ClearActionButton {...{ selectedDeals, handleDeselectAll, isLogged, hasMarketsAccess, setSignUpModalIsOpen, setUserRolesModalIsOpen }} />
    </Grid>
    <Grid item xs={12} sm={12} md={6} lg={8}>
      <CompareActionButton {...{
        disabled,
        selectedDeals,
        handleCompareSelectedDeals,
        isLogged,
        hasMarketsAccess,
        setSignUpModalIsOpen,
        setUserRolesModalIsOpen
      }}
      />
    </Grid>
  </Grid>
)

const ClearActionButton = ({ selectedDeals, handleDeselectAll: onClick, setSignUpModalIsOpen, setUserRolesModalIsOpen, isLogged, hasMarketsAccess }) => {
  const label = selectedDeals.length === 0 ? 'Clear selection' : `Clear selection (${selectedDeals.length})`
  const disabled = selectedDeals.length < 1

  return (
    <HeaderActionButton type='CLEAR' {...{ label, disabled, onClick, setSignUpModalIsOpen, setUserRolesModalIsOpen, isLogged, hasMarketsAccess }} />
  )
}

const CompareActionButton = ({
  disabled,
  selectedDeals,
  handleCompareSelectedDeals: onClick,
  setSignUpModalIsOpen,
  setUserRolesModalIsOpen,
  isLogged,
  hasMarketsAccess
}) => {
  const suffix = disabled ? '' : `(${selectedDeals.length})`
  const label = `Compare selected deals from all sessions ${suffix}`

  return (
    <HeaderActionButton
      type='COMPARE'
      description={disabled ? 'Select 2 or more deals to compare' : undefined}
      {...{
        label,
        disabled,
        onClick,
        setSignUpModalIsOpen,
        setUserRolesModalIsOpen,
        isLogged,
        hasMarketsAccess
      }}
    />
  )
}

const HeaderActionButton = ({
  type,
  disabled,
  onClick,
  label,
  description,
  className,
  setSignUpModalIsOpen,
  setUserRolesModalIsOpen,
  isLogged,
  hasMarketsAccess
}) => {
  const handleOnClick = (e) => {
    dismissPopover(e.target)
    if (type === 'COMPARE' && guardMarketsAccess(e, { isLogged, hasMarketsAccess, setSignUpModalIsOpen, setUserRolesModalIsOpen })) {
      return
    }
    onClick()
  }

  return (
    <TealToolTip title={description || ''}>
      <div
        className={cx('cadet-blue bg-white br2', className)}
      >
        <Button {...{ disabled, handleOnClick, label }} />
      </div>
    </TealToolTip>
  )
}

const Button = ({ disabled = false, handleOnClick: onClick, label }) => {
  const classes = {
    root: cx(
      'w-100 tracked-cosy b ttn f7-m',
      { 'black header-action-button': !disabled },
      { 'bg-white header-action-button-disabled': disabled }
    )
  }

  return (
    <MuiButton {...{ disabled, classes, onClick }}>
      {label}
    </MuiButton>
  )
}
